import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";

@Component({
	selector: "dmv-address-change-model",
	templateUrl: "./address-change-model.component.html",
	styleUrls: ["./address-change-model.component.css"]
})
export class AddressChangeModelComponent implements OnInit {
	constructor(public dmvStoreService: DMVStoreService) {}
	public isPopupOpen: boolean = true;

	@Output() public noConfirm: EventEmitter<any> = new EventEmitter();
	@Output() public yesConfirm: EventEmitter<any> = new EventEmitter();
	@Output() public forgetItConfirm: EventEmitter<any> = new EventEmitter();

	public allowMailingToTempAddress: boolean;
	public allowAddressUpdate: boolean;

	public yesButtonText: string;
	public noButtonText: string;
	public messageText: string;
	public forgotButtonText: string;
	ngOnInit() {
		this.allowAddressUpdate = this.dmvStoreService.agencyConfig.agencyDmvConfig.allowAddressUpdate;
		this.allowMailingToTempAddress = this.dmvStoreService.agencyConfig.agencyDmvConfig.allowMailingToTempAddress;

		if (this.allowMailingToTempAddress && this.allowAddressUpdate) {
			this.yesButtonText = "Yes, update my address in DMV’s records";
			this.noButtonText = "No, this is a temporary mailing address";
			this.forgotButtonText = "Forget it, undo my changes";
			this.messageText = this.dmvStoreService.agencyConfig.agencyDmvConfig.addressChangePopupTextPAndT;
		} else if (!this.allowMailingToTempAddress && this.allowAddressUpdate) {
			this.yesButtonText = "Yes";
			this.noButtonText = "No, discard my changes";
			this.messageText = this.dmvStoreService.agencyConfig.agencyDmvConfig.addressChangePopupTextPOnly;
		} else {
			this.yesButtonText = "Yes";
			this.noButtonText = "No, discard my changes";
			this.messageText = this.dmvStoreService.agencyConfig.agencyDmvConfig.addressChangePopupTextTOnly;
		}
	}
	public yes() {
		this.isPopupOpen = false;
		this.yesConfirm.emit();
	}
	public no() {
		this.isPopupOpen = false;
		this.noConfirm.emit();
	}
	public forgetIt() {
		this.isPopupOpen = false;
		this.forgetItConfirm.emit();
	}
}
